import { useEffect, useRef, useState } from "react";
import { TextInput } from "@normasteaching/norma-ui";

export function DebouncedSearchInput({
  value,
  onSearch,
  placeholder,
  delayMs = 300,
}: {
  value: string;
  onSearch: (search: string) => void;
  placeholder: string;
  delayMs?: number;
}) {
  const [inputValue, setInputValue] = useState(value);
  const searchTimeoutRef = useRef<NodeJS.Timeout>();
  const lastTypedSearchRef = useRef(value);

  useEffect(() => {
    const isChangedOutsideTheInput =
      value !== lastTypedSearchRef.current.trim();
    if (isChangedOutsideTheInput) {
      lastTypedSearchRef.current = value;
      setInputValue(value);
    }
  }, [value]);

  useEffect(() => () => clearTimeout(searchTimeoutRef.current), []);

  return (
    <TextInput
      placeholder={placeholder}
      value={inputValue}
      onChange={(e) => {
        const typed = e.target.value;
        setInputValue(typed);
        lastTypedSearchRef.current = typed;
        clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(() => onSearch(typed), delayMs);
      }}
    />
  );
}
